import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",  // reduced from 14px
};

const rowStyle = {
  display: "flex",
  gap: "12px", // reduced from 20px
  flexWrap: "wrap",
};

const sectionLabel = {
  fontSize: "13px", // reduced from 16px
  color: "#1d1d1dff",
  fontWeight: "500",
};

const groupStyle = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  gap: "4px", // reduced from 6px
  minWidth: "180px", // reduced from 220px to keep smaller spacing
};

const inputStyle = {
  padding: "6px", // reduced from 8px
  borderRadius: "5px",
  border: "1px solid #dedede",
  
  fontSize: "14px", // reduced from 13px
};

const btnStyle = {
  padding: "6px 14px", // reduced from 8px 18px
  border: "none",
  borderRadius: "8px",
  background: "#111111ff",
  color: "#fff",
  cursor: "pointer",
  fontSize: "11px", // reduced from 13px
  alignSelf: "flex-end",
};

const AddDistributor = ({ existingData = null, handleSave, closeForm }) => {
  const formik = useFormik({
  enableReinitialize: true, // <-- Important!
  initialValues: {
    gstin: existingData?.gst || "",
    district: existingData?.district || "",
    distributorName: existingData?.name || "",
    mobile: existingData?.mobile || "",
    email: existingData?.email || "",
    address: existingData?.address || "",
    license: existingData?.license || "",
    openingBalance: existingData?.balance || "",
    openingDate: existingData?.openingDate || "",
    shortageCalc: existingData?.shortageCalc || "consider",
  },
  validationSchema: Yup.object({
    gstin: Yup.string().required("*Required"),
    district: Yup.string().required("*Required"),
    distributorName: Yup.string().required("*Required"),
    mobile: Yup.string().required("*Required"),
  }),
  onSubmit: () => {},
});

  const handleSaveClick = async () => {
    const isValid = await formik.validateForm();

    if (
      !isValid.gstin &&
      !isValid.district &&
      !isValid.distributorName &&
      !isValid.mobile
    ) {
      const values = formik.values;

      const newDistributor = {
        name: values.distributorName,
        mobile: values.mobile,
        gst: values.gstin,
        balance: values.openingBalance,
        district: values.district,
        email: values.email,
        address: values.address,
        license: values.license,
        openingDate: values.openingDate,
      };

      handleSave(newDistributor);
      closeForm();
    } else {
      // Mark all fields as touched so errors show
      formik.setTouched({
        gstin: true,
        district: true,
        distributorName: true,
        mobile: true,
      });
    }
  };

  return (
    <div style={{ padding: "12px", maxWidth: "800px", margin: "0 auto" }}>
      <div style={{ marginBottom: "12px" }}>
        <h2 style={{ margin: 0, fontSize: "18px" }}>Add New Distributor</h2>
        <span style={{ fontSize: "11px", color: "#888" }}>
          Fill in the details below to add
        </span>
      </div>

      <form
        style={formStyle}
        onSubmit={formik.handleSubmit}
        noValidate
      >
        <div
          style={{
            ...inputStyle,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
            cursor: "pointer",
          }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "ArrowRight") {
              formik.setFieldValue("shortageCalc", "ignore");
            } else if (e.key === "ArrowLeft") {
              formik.setFieldValue("shortageCalc", "consider");
            }
          }}
        >
          <span style={sectionLabel}>Purchase Bill Has</span>
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
              }}
            >
              <input
                type="radio"
                name="shortageCalc"
                value="consider"
                checked={formik.values.shortageCalc === "consider"}
                onChange={formik.handleChange}
                style={{ accentColor: "#6c0aad", cursor: "pointer" }}
              />
              <span style={{ fontSize: "12px", color: "#1f1e1eff" }}>GST Column</span>
            </label>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                cursor: "pointer",
              }}
            >
              <input
                type="radio"
                name="shortageCalc"
                value="ignore"
                checked={formik.values.shortageCalc === "ignore"}
                onChange={formik.handleChange}
                style={{ accentColor: "#6c0aad", cursor: "pointer" }}
              />
              <span style={{ fontSize: "12px", color: "#1f1e1eff" }}>No GST Column</span>
            </label>
          </div>
        </div>

        <div style={rowStyle}>
          <div style={groupStyle}>
            <label style={{ fontSize: "13px" }}>
              Distributor GSTIN <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="gstin"
              placeholder="Enter GSTIN here"
              className="custom-placeholder"
              maxLength={15}
              style={inputStyle}
              value={formik.values.gstin}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.gstin && formik.errors.gstin && (
              <div style={{ color: "red", fontSize: "10px" }}>{formik.errors.gstin}</div>
            )}
          </div>

          <div style={groupStyle}>
  <label style={{ fontSize: "13px" }}>
    District Name <span style={{ color: "red" }}>*</span>
  </label>
  <select
    name="district"
    style={inputStyle}
    value={formik.values.district}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
  >
    <option className="custom-placeholder" value="">-- Select District --</option>
    <option value="Mumbai">Mumbai</option>
    <option value="Pune">Pune</option>
    <option value="Nagpur">Nagpur</option>
    <option value="Nashik">Nashik</option>
    <option value="Thane">Thane</option>
    <option value="Aurangabad">Aurangabad</option>
    <option value="Solapur">Solapur</option>
    <option value="Amravati">Amravati</option>
    <option value="Kolhapur">Kolhapur</option>
    <option value="Sangli">Sangli</option>
    {/* Add or change options as needed */}
  </select>
  {formik.touched.district && formik.errors.district && (
    <div style={{ color: "red", fontSize: "10px" }}>{formik.errors.district}</div>
  )}
</div>
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "13px" }}>
            Distributor’s Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="distributorName"
            placeholder="Enter Full Buisness Name Here.."
            className="custom-placeholder"
            style={inputStyle}
            value={formik.values.distributorName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.distributorName && formik.errors.distributorName && (
            <div style={{ color: "red", fontSize: "10px" }}>{formik.errors.distributorName}</div>
          )}
        </div>

        <div style={rowStyle}>
          <div style={groupStyle}>
            <label style={{ fontSize: "13px" }}>
              Mobile Number <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="mobile"
              placeholder="Enter mobile no.."
              className="custom-placeholder"
              maxLength={10}
              style={inputStyle}
              
              value={formik.values.mobile}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.mobile && formik.errors.mobile && (
              <div style={{ color: "red", fontSize: "10px" }}>{formik.errors.mobile}</div>
            )}
          </div>

          <div style={groupStyle}>
            <label style={{ fontSize: "13px" }}>Email ID (Optional)</label>
            <input
              type="email"
              name="email"
              placeholder="Enter Email ID here"
              className="custom-placeholder"
              style={inputStyle}
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "13px" }}>Distributor’s Address (Optional)</label>
          <input
            type="text"
            name="address"
            placeholder="Enter Full Address Here.."
            className="custom-placeholder"
            style={inputStyle}
            value={formik.values.address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>

        <div style={groupStyle}>
          <label style={{ fontSize: "13px" }}>Distributor’s Drug License (Optional)</label>
          <input
            type="text"
            name="license"

            style={inputStyle}
            value={formik.values.license}
            onChange={formik.handleChange}
            placeholder="Enter Form 20 & Form 21 here"
            className="custom-placeholder"
            onBlur={formik.handleBlur}
          />
        </div>

        <div style={rowStyle}>
          <div style={groupStyle}>
            <label style={{ fontSize: "13px" }}>Opening Balance (Optional)</label>
            <input
              type="text"
              name="openingBalance"
              placeholder="Enter Amount Here"
              className="custom-placeholder"
              style={inputStyle}
              value={formik.values.openingBalance}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div style={groupStyle}>
            <label style={{ fontSize: "13px" }}>Opening Balance Date (Optional)</label>
            <input
              type="date"
              name="openingDate"
              placeholder="Opening Balance Date"
              className="custom-placeholder"
              style={inputStyle}
              value={formik.values.openingDate}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop:"5px"}}>
          <button
            type="button"
            onClick={handleSaveClick}
            className="gradient-button"
            onMouseEnter={(e) =>
              (e.currentTarget.style.boxShadow = "0 6px 14px rgba(25, 118, 210, 0.5)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.boxShadow = "0 4px 8px rgba(25, 118, 210, 0.3)")
            }
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDistributor;
